export const TABLE_UPDATE = "LOCATION_GROUPS/TABLE_UPDATE";
export const FETCH_SUCCESS = "LOCATION_GROUPS/FETCH_SUCCESS";

const types = {
    DESTROY_FAILED: "LOCATION_GROUPS/DESTROY_FAILED",
    DESTROY_REQUEST: "LOCATION_GROUPS/DESTROY_REQUEST",
    DESTROY_SUCCESS: "LOCATION_GROUPS/DESTROY_SUCCESS",

    FETCH_FAILED: "LOCATION_GROUPS/FETCH_FAILED",
    FETCH_REQUEST: "LOCATION_GROUPS/FETCH_REQUEST",
    FETCH_SUCCESS,

    FETCH_ALL_FAILED: "LOCATION_GROUPS/FETCH_ALL_FAILED",
    FETCH_ALL_REQUEST: "LOCATION_GROUPS/FETCH_ALL_REQUEST",
    FETCH_ALL_SUCCESS: "LOCATION_GROUPS/FETCH_ALL_SUCCESS",

    GET_FAILED: "LOCATION_GROUPS/GET_FAILED",
    GET_REQUEST: "LOCATION_GROUPS/GET_REQUEST",
    GET_SUCCESS: "LOCATION_GROUPS/GET_SUCCESS",

    PATCH_FAILED: "LOCATION_GROUPS/PATCH_FAILED",
    PATCH_REQUEST: "LOCATION_GROUPS/PATCH_REQUEST",
    PATCH_SUCCESS: "LOCATION_GROUPS/PATCH_SUCCESS",
    
    STORE_FAILED: "LOCATION_GROUPS/STORE_FAILED",
    STORE_REQUEST: "LOCATION_GROUPS/STORE_REQUEST",
    STORE_SUCCESS: "LOCATION_GROUPS/STORE_SUCCESS",

    UPDATE_FAILED: "LOCATION_GROUPS/UPDATE_FAILED",
    UPDATE_REQUEST: "LOCATION_GROUPS/UPDATE_REQUEST",
    UPDATE_SUCCESS: "LOCATION_GROUPS/UPDATE_SUCCESS",
    TABLE_UPDATE,
};

export default types;
